import { useRef } from 'react'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import LayoutContent from '@/components/LayoutContent'
import { useGetBuildingsQuery } from '@/api'
import WidgetSelectorTabs from './components/WidgetSelectorTabs';
import usePermittedWidgets from './components/usePermittedWidgets';
import WidgetsTableOfContent from './components/WidgetsTableOfContent';
import StatWidgetsAppBar from './components/StatWidgetsAppBar';

const MainPage = () => { 
  const widgetElsMapRef = useRef(new Map());
  // const buildingId = useSelector(selectBuildingId);
  // const activeBuildingId = useSelector(selectActiveBuildingId);
  const { isSuccess: buildingSuccess } = useGetBuildingsQuery();
  const {
    permittedTabsList,
    activeTabWidgetsList,
    activeTab,
    setActiveTab
  } = usePermittedWidgets();
  const scrollToWidgetById = (val) => {
    const el = widgetElsMapRef.current.get(val)
    if (!el) return;
    const elementPosition = el.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 65;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
  // To store or request
  return (
    buildingSuccess && (
      <LayoutContent
        headerContent={ 
          <>
            <StatWidgetsAppBar /> 
            { 
              permittedTabsList && permittedTabsList?.length > 0 && (
                <WidgetSelectorTabs
                  widgets={ permittedTabsList }
                  activeTabId={ activeTab }
                  onWidgetSelect={(tabId) => setActiveTab(tabId)}
                /> 
              )
            }
          </>
        }
        containerProps={{ 
          disableGutters: true,
          sx: {}
        }}
      >
          <Grid 
            container 
            spacing={2}
            sx={{
              pt: 2,
              px: 2,
            }}
          >
            {
              (activeTabWidgetsList?.length && activeTabWidgetsList?.length > 1) 
                ? <WidgetsTableOfContent 
                    widgets={activeTabWidgetsList}
                    key={activeTab}
                    onItemClick={scrollToWidgetById}
                  />
                : null
            }
            { 
              (activeTabWidgetsList?.length && activeTabWidgetsList?.length > 1) 
                ? <Grid 
                    size={{
                      xs: 12,
                      md: 10,
                    }}
                    sx={{
                      pb: 2,
                    }}
                  >
                    <Stack 
                      direction="column" 
                      spacing={3}
                    >
                      {
                        activeTabWidgetsList?.map(widgetItem => (
                          <widgetItem.node 
                            key={widgetItem.key}
                            ref={(el) => {
                              if (el) widgetElsMapRef.current.set(widgetItem.key, el)
                                // return () => {
                                //   widgetElsMapRef.current.delete(widgetItem.key);
                                // }
                              
                            }}
                            id={widgetItem.key}
                          />
                        ))
                      }
                    </Stack>
                  </Grid> 
                : activeTabWidgetsList?.map(WidgetItem => 
                  <WidgetItem.node key={WidgetItem.key} id={WidgetItem.key}/>
                )
            }
          </Grid>
        {/* </FadeInSection> */}
      </LayoutContent>
    )
  )
}

export default MainPage;